export const ICON_SIZE_36 = 36;
export const ICON_SIZE_30 = 30;
export const ICON_SIZE_24 = 24;
export const ICON_SIZE_20 = 20;
